import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from 'react';
import { composeEventHandlers } from '@radix-ui/primitive';
import * as Slider from '@radix-ui/react-slider';
import { useCallbackRef } from '@radix-ui/react-use-callback-ref';
const Track = Slider.Track;
const Range = Slider.Range;
const Thumb = Slider.Thumb;
const rangeFacetContext = React.createContext([]);
const RangeFacetProvider = rangeFacetContext.Provider;
const Root = React.forwardRef((props, forwardedRef) => {
    const { facetId, onFacetChange, min, max, steps = 1, dir = 'ltr', value, onValueChange, autoAdjustValues = true, ...rangeFacetProps } = props;
    const [minValue = min, maxValue = max] = value || [];
    const valueMin = !autoAdjustValues || minValue >= min ? minValue : min;
    const valueMax = !autoAdjustValues || maxValue <= max ? maxValue : max;
    const [values = [], setValues] = useState(value);
    useEffect(() => {
        setValues([valueMin, valueMax]);
    }, [valueMin, valueMax]);
    const onRangeChangeHandler = useCallbackRef((value) => {
        onFacetChange &&
            onFacetChange({
                facetId,
                min: value[0],
                max: value[1],
                type: 'range',
            });
    });
    return (_jsx(RangeFacetProvider, { value: values, children: _jsx(Slider.Root, { value: values, max: max, min: min, step: steps, onValueCommit: onRangeChangeHandler, onValueChange: composeEventHandlers(onValueChange, (newValues) => {
                setValues(newValues);
            }), dir: dir, ref: forwardedRef, ...rangeFacetProps }) }));
});
const Start = React.forwardRef((props, forwardedRef) => {
    const context = useContext(rangeFacetContext);
    return (_jsx(Slider.Thumb, { ...props, ref: forwardedRef, children: typeof props.children === 'function' && props.children(context[0]) }));
});
const End = React.forwardRef((props, forwardedRef) => {
    const context = useContext(rangeFacetContext);
    return (_jsx(Slider.Thumb, { ...props, ref: forwardedRef, children: typeof props.children === 'function' && props.children(context[1]) }));
});
export { Root, Range, Track, Thumb, Start, End };
